
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

let resolve;

/**
 * Usage:
 *  1) async/await variant
 *
 *      let result = await DialogPrompt.show('Prompt');
 *      if (result) {
 *          // do action
 *      }
 *
 *  2) promise variant
 *
 *       DialogPrompt.show('Prompt').then(result => {
 *           if (result) {
 *               // do action
 *           }
 *       });
 */
class DialogPrompt extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogPrompt/>, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            message: '',
            text: '',
            options: {}
        };
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(false);
    }

    handleConfirm = () => {
        this.setState({hidden: true});
        resolve(this.state.text);
    }

    handleChangeText = (event) => {
        this.setState({text: event.target.value});
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            this.handleConfirm();
        }
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                onDismiss={this.handleCancel}
                minWidth={this.state.options.minWidth || null}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: this.state.options.title || 'Zadejte text'
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                <div>
                    <div dangerouslySetInnerHTML={{__html: this.state.message}} />
                    <TextField
                        value={this.state.text}
                        onChange={this.handleChangeText}
                        onKeyDown={this.handleKeyDown}
                        />
                </div>
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Ok" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(message, options) {
        this.setState({
            hidden: false,
            text: ((options && options.value) ? options.value : ''),
            message: message,
            options: options || {}
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogPrompt.create();
